<template>
    <div id="cfsBatchUpdate">
        <a-modal v-model="visible" :title="$t('cycleCount.createTicket')" :maskClosable="false"  >
            <template slot="footer">
                <a-button size="small" type="primary" @click="save" icon="save">{{ $t('login.Create') }}</a-button>
            </template>
            <a-form :form="form" >

                <a-form-item :label="$t('cycleCount.includeStatus')"  v-bind="formItemLayout">
                    <a-checkbox style="margin-left: 10px" v-model="cbNew"><label style="color: #2b9ed6;">{{ $t('pubGicSet.New') }}</label></a-checkbox>
                    <a-checkbox style="margin-left: 10px" v-model="cbReCount"><label style="color: #2b9ed6;">{{ $t('cycleCount.reCount') }}</label></a-checkbox>
                </a-form-item>
                <a-form-item :label="$t('cycleCount.numberOfSplit')"  v-bind="formItemLayout" >
                    <a-input type="number" size="small" style="width: 80%" v-model="inputNumberOfSplit"/>
                </a-form-item>

            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data() {
            return{
                scHeaderUid: '',
                cbReCount:false,
                cbNew:false,
                inputNumberOfSplit:'',
                ajaxtype: '',

                visible: false,
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },

        methods:{
            show(scHeaderUid) {
                this.scHeaderUid = scHeaderUid
                this.visible = true

                this.resetData();
            },
            save(){
                  // 至少选一个，否则报错
                   if(!(this.cbReCount || this.cbNew )) {
                       this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                       return;
                   }

                   // 不为空且为正整数 否则报错
                   if(null == this.inputNumberOfSplit || '' == this.inputNumberOfSplit || parseInt(this.inputNumberOfSplit) <= 0) {
                       this.$customMessage.warning(this.$t('cycleCountMaster.quantityNeedsToBeGreaterThan0'));
                       return;
                   }

                   let params = {}
                   let ajaxTypeName = ''
                   ajaxTypeName = api.INVENTORYCYCLECOUNTCREATETICKETBYNEWORRECOUNT
                   params = {
                       "uid": this.scHeaderUid,
                       "cbReCount": this.cbReCount,
                       "cbNew":this.cbNew,
                       "inputNumberOfSplit": this.inputNumberOfSplit,
                   }
                   ajax.post(ajaxTypeName,params).then(res=>{
                       if(res.code == 200){
                           this.$message.success(res.msg)
                           this.visible = false
                       }else{
                           this.$customMessage.warning(res.msg)
                       }
                   })


            },
            resetData() {
                this.cbReCount=false;
                this.cbNew=false;
                this.inputNumberOfSplit= '';
            }
        }
    }
</script>